import React, { useState } from "react";

const FilterIcon = ({ isActive, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Default state
  let backgroundColor = "transparent";
  let fillColor = "#969BA9";
  let showActivePath = false;

  // Hover (only when not active)
  if (isHovered && !isActive) {
    backgroundColor = "#F6F6F6";
    fillColor = "var(--color-primary)";
  }

  // Active (drawer open)
  if (isActive) {
    backgroundColor = "var(--color-primary)";
    fillColor = "#FFFFFF";
    showActivePath = true;
  }

  return (
    <span
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "26px",
        height: "26px",
        borderRadius: "50%",
        backgroundColor,
        cursor: "pointer",
        // transition: "all 0.2s ease",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 27 27"
        fill="none"
        style={{
          transform: "translateY(1px)", // perfect vertical centering tweak
          // transition: "fill 0.2s ease",
        }}
      >
        <path
          d="M7.77211 7.08333V8.24999C7.77097 8.39379 7.81953 8.53298 7.90848 8.64082L12.1357 13.7216V19.9166C12.1343 20.1384 12.2506 20.3418 12.4357 20.4416C12.5122 20.4812 12.5962 20.5012 12.6812 20.4999C12.7992 20.4999 12.914 20.459 13.0085 20.3833L15.1903 18.6333C15.3276 18.5231 15.4085 18.3502 15.4085 18.1666V13.7216L19.6357 8.64082C19.7247 8.53298 19.7732 8.39379 19.7721 8.24999V7.08333C19.7721 6.76117 19.5279 6.5 19.2266 6.5H8.31757C8.01632 6.5 7.77211 6.76117 7.77211 7.08333Z"
          fill={fillColor}
        />

        {showActivePath && (
          <path
            d="M16.9876 12.1371C15.2002 12.1371 13.7471 13.5902 13.7471 15.3776C13.7471 15.9848 13.9176 16.5578 14.2178 17.049C14.7772 17.9905 15.8073 18.6181 16.9876 18.6181C18.1678 18.6181 19.1979 17.9836 19.7574 17.049C20.0575 16.5646 20.2281 15.9848 20.2281 15.3776C20.2281 13.5902 18.7818 12.1371 16.9876 12.1371ZM18.2156 16.5851C18.1132 16.6874 17.9836 16.7352 17.854 16.7352C17.7244 16.7352 17.5947 16.6874 17.4924 16.5851L17.0012 16.0939L16.4896 16.6056C16.3872 16.7079 16.2576 16.7557 16.128 16.7557C15.9984 16.7557 15.8687 16.7079 15.7664 16.6056C15.5686 16.4077 15.5686 16.0803 15.7664 15.8824L16.2781 15.3708L15.7869 14.8728C15.589 14.6749 15.589 14.3475 15.7869 14.1496C15.9847 13.9518 16.3122 13.9518 16.51 14.1496L17.0012 14.6408L17.4788 14.1633C17.6766 13.9654 18.0041 13.9654 18.2019 14.1633C18.3998 14.3611 18.3998 14.6886 18.2019 14.8864L17.7244 15.3639L18.2156 15.862C18.4202 16.0598 18.4202 16.3873 18.2156 16.5851Z"
            fill="var(--color-active)"
          />
        )}
      </svg>
    </span>
  );
};

export default FilterIcon;
